import React, { useState } from 'react'

import styles from './CollapsibleFilter.module.scss';

type CollapsibleFilterType = {
    category?: string;
    categoryValues?: Array<{
        id: string;
        name?: string;
        count?: number
    }>;
}

export default function CollapsibleFilter({
    category,
    categoryValues
}: CollapsibleFilterType) {
    const [collapse, setCollapse] = useState<boolean>(true);
    const [filterValues, setFilterValues] = useState<string[]>([]);
    const onFilterSelect = (event: any) => {
        const filterVal = categoryValues?.find(cat => cat.id == event.target.id);
        let tempFilterValues = [...filterValues];
        if(event.target.checked) {
            tempFilterValues.push(filterVal?.name!);
        } else {
            const filterIndex = tempFilterValues.findIndex(fv => fv == filterVal?.name!);
            tempFilterValues.splice(filterIndex, 1);
        }
        setFilterValues(tempFilterValues);
    }

    const handleClear = () => {
        setFilterValues([]);
    }
    return (
        <div className={styles.filterWrapper}>
            <div className={styles.header} onClick={() => setCollapse(!collapse)}>
                {category}
                <div>
                    <span className={styles.clear} onClick={handleClear}>Clear</span>
                    <span className={collapse ? 'icon-chevron-down' : 'icon-chevron-up'}></span>
                </div>
            </div>
            {(collapse && filterValues.length > 0) ? (<div className={styles.appliedFilters}>{filterValues.join(',')}</div>) : null}
            <div className={collapse ? styles.collapse : styles.expand}>
                {categoryValues?.map(val => (
                    <div className={styles.categoryValues} key={val.id}>
                        <div className={styles.selectWrapper}>
                            <input type='checkbox' id={val.id} onChange={onFilterSelect}
                                checked={filterValues.findIndex(fv => fv == val.name) > -1}></input>
                            <label htmlFor={val.id}>{val.name}</label>
                        </div>
                        <div className={styles.count}>
                            {val.count}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
